/* ==========================================================================
   MAVEN'S GARDEN - LUXURY INTERACTIVE JAVASCRIPT
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  // 1. FAQ Accordion Toggle
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        faqItems.forEach(otherItem => otherItem.classList.remove('active'));
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });

  // 2. Cart Drawer Management
  const cartTrigger = document.querySelector('.cart-icon-btn');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const closeDrawerBtns = document.querySelectorAll('.close-drawer-btn');

  function openCartDrawer() {
    if (cartOverlay && cartDrawer) {
      cartOverlay.classList.add('open');
      cartDrawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartOverlay && cartDrawer) {
      cartOverlay.classList.remove('open');
      cartDrawer.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  closeDrawerBtns.forEach(btn => btn.addEventListener('click', closeCartDrawer));

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  // 3. Cart Drawer AJAX Item Removal & Quantity Management
  const cartContainer = document.getElementById('CartDrawerItems');
  const cartCountBadge = document.querySelector('.cart-count-badge');
  const cartSubtotalEl = document.getElementById('CartDrawerSubtotal');

  if (cartContainer) {
    cartContainer.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.cart-remove-btn');
      const qtyBtn = e.target.closest('.qty-btn');

      // Removal
      if (removeBtn) {
        e.preventDefault();
        const line = removeBtn.getAttribute('data-line');
        const key = removeBtn.getAttribute('data-key');
        const cartItemEl = removeBtn.closest('.cart-drawer-item');

        if (window.location.protocol === 'file:' || !window.Shopify) {
          // Preview mode simulation
          if (cartItemEl) {
            cartItemEl.remove();
            const remainingItems = cartContainer.querySelectorAll('.cart-drawer-item');
            if (cartCountBadge) cartCountBadge.textContent = remainingItems.length;
            if (remainingItems.length === 0) {
              if (cartSubtotalEl) cartSubtotalEl.textContent = '$0.00';
              cartContainer.innerHTML = `
                <div class="cart-empty-message" style="text-align: center; padding: 40px 0; color: var(--text-muted);">
                  <div style="margin-bottom: 12px; color: var(--gold-primary);">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z"/><path d="M3 6H21"/><path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"/></svg>
                  </div>
                  <p style="font-size: 0.95rem;">Your cart is currently empty.</p>
                  <a href="#products" class="btn btn-outline" onclick="closeCartDrawer()" style="margin-top: 16px; font-size: 0.85rem; padding: 10px 18px;">Explore Remedies</a>
                </div>
              `;
            }
          }
          return;
        }

        // Live Shopify AJAX removal
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
        })
        .then(res => res.json())
        .then(cart => {
          window.location.reload();
        })
        .catch(err => {
          window.location.href = `/cart/change?line=${line}&quantity=0`;
        });
      }

      // Quantity adjustments
      if (qtyBtn) {
        e.preventDefault();
        const line = qtyBtn.getAttribute('data-line');
        const delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
        const cartItemEl = qtyBtn.closest('.cart-drawer-item');
        const qtyValEl = cartItemEl ? cartItemEl.querySelector('.qty-value') : null;

        if (qtyValEl) {
          let currentQty = parseInt(qtyValEl.textContent, 10) || 1;
          let newQty = currentQty + delta;
          if (newQty <= 0) {
            removeBtn ? removeBtn.click() : null;
            return;
          }

          if (window.location.protocol === 'file:' || !window.Shopify) {
            qtyValEl.textContent = newQty;
            return;
          }

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: newQty })
          })
          .then(res => res.json())
          .then(cart => {
            window.location.reload();
          });
        }
      }
    });
  }

  // 4. Policy Modal Popups
  const policyTriggers = document.querySelectorAll('.policy-link-trigger');
  const policyOverlay = document.querySelector('.policy-modal-overlay');
  const policyModal = document.querySelector('.policy-modal');
  const closePolicyBtn = document.querySelector('.close-policy-btn');
  const policyModalTitle = document.querySelector('.policy-modal-title');
  const policyModalContent = document.querySelector('.policy-modal-content');

  const policiesData = {
    shipping: {
      title: "📦 Shipping & 100% Discretion Policy",
      content: `
        <h4>100% Discreet & Confidential Packaging</h4>
        <p>All orders from Maven's Garden are packaged and shipped in sealed, completely plain brown unmarked boxes or envelopes. There are no brand logos, no product names, and no descriptions of the contents anywhere on the parcel exterior. Your privacy is 100% protected.</p>
        
        <h4>Fast US Domestic Delivery</h4>
        <p>We process and dispatch all orders within 24 to 48 business hours. Orders within the United States are delivered via expedited courier in <strong>2 to 4 business days</strong>.</p>

        <h4>Tracking & Notifications</h4>
        <p>As soon as your package is dispatched, you will receive a confirmation email with a direct tracking link so you can monitor your parcel securely from warehouse to your doorstep.</p>
      `
    },
    privacy: {
      title: "🔒 Privacy & Data Confidentiality Policy",
      content: `
        <h4>Complete Confidentiality</h4>
        <p>At Maven's Garden (by Eagle American Seller LLC), we respect your personal privacy above all else. We will never sell, lease, or distribute your private information, name, address, or email to third parties.</p>

        <h4>Secure 256-Bit SSL Encryption</h4>
        <p>All sensitive transactions are processed using military-grade 256-bit SSL encryption provided by Shopify's certified infrastructure. We do not store or have access to your full credit card numbers.</p>

        <h4>Contact & Inquiries</h4>
        <p>For any questions regarding your data or to request account deletion, please email our support team directly at <strong style="color: var(--gold-light);">mavensgarden01@gmail.com</strong>.</p>
      `
    },
    refund: {
      title: "🛡️ Quality Guarantee & Return Policy",
      content: `
        <h4>Authenticity Guarantee</h4>
        <p>We guarantee that all our roots and formulas are 100% authentic, ethically wild-harvested in West Africa, and free from synthetic additives or chemicals.</p>

        <h4>Damaged or Incomplete Parcels</h4>
        <p>If your package arrives damaged during transit, contact us at <strong>mavensgarden01@gmail.com</strong> within 7 days with photos for an immediate replacement package free of charge.</p>
      `
    },
    terms: {
      title: "📜 Terms of Service",
      content: `
        <h4>Adults Only (18+)</h4>
        <p>Our formulas and products are strictly intended for responsible use by adults aged 18 and older.</p>

        <h4>General Wellness & Traditional Herbal Heritage</h4>
        <p>Statements made on this website are based on traditional West African botanical practices. Always follow product guidelines and consult your medical healthcare provider if you have pre-existing medical conditions.</p>
      `
    }
  };

  function openPolicy(policyKey) {
    const policy = policiesData[policyKey];
    if (policy && policyModalTitle && policyModalContent && policyOverlay && policyModal) {
      policyModalTitle.innerHTML = policy.title;
      policyModalContent.innerHTML = policy.content;
      policyOverlay.classList.add('open');
      policyModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closePolicy() {
    if (policyOverlay && policyModal) {
      policyOverlay.classList.remove('open');
      policyModal.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  policyTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const policyKey = trigger.getAttribute('data-policy');
      if (policyKey) openPolicy(policyKey);
    });
  });

  if (policyOverlay) policyOverlay.addEventListener('click', closePolicy);
  if (closePolicyBtn) closePolicyBtn.addEventListener('click', closePolicy);

  // 5. Smooth Anchor Scrolling
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId.length > 1) {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
});
